export const ROLES = {
  ADMIN: "Admin",
  HOST: "Host",
  GENERAL_MANAGER: "General Manager",
  RESERVATION_MANAGER: "Reservation Manager",
  GUEST_EXPERIENCE_MANAGER: "Guest Experience Manager",
  FINANCIAL_MANAGER: "Financial Manager",
  DISTRIBUTION_MANAGER: "Distribution Manager",
  REVENUE_MANAGER: "Revenue Manager",
  SALES_MANAGER: "Sales Manager",
  PROPERTY_OPERATIONS_MANAGER: "Property Operations Manager",
  TRAVELER: "Traveler",
};

export const HOST_ROLES = [
  ROLES.ADMIN,
  ROLES.HOST,
  ROLES.GENERAL_MANAGER,
  ROLES.RESERVATION_MANAGER,
  ROLES.GUEST_EXPERIENCE_MANAGER,
  ROLES.FINANCIAL_MANAGER,
  ROLES.DISTRIBUTION_MANAGER,
  ROLES.REVENUE_MANAGER,
  ROLES.SALES_MANAGER,
  ROLES.PROPERTY_OPERATIONS_MANAGER,
];

export const GUEST_ROLES = [
  ROLES.TRAVELER,
  ...HOST_ROLES,
];
